import { render, staticRenderFns } from "./exercises-library-result.vue?vue&type=template&id=54318b9a"
import script from "./exercises-library-result.vue?vue&type=script&lang=js"
export * from "./exercises-library-result.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports